<template>
  <div class="translation-pair" data-test-id="translation-pair">
    <p
      :lang="languageCode"
      class="translation-pair__text"
      data-test-id="translation-pair-text"
    >
      {{ text }}
    </p>
    <p class="translation-pair__language" data-test-id="translation-pair-language">
      {{ language }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
    languageCode: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.translation-pair__text,
.translation-pair__language {
  margin: 0;
}

.translation-pair__text {
  font-size: $font-3l;
  font-weight: $font-weight-1l;
}

.translation-pair__language {
  color: var(--color-text-secondary);
  font-size: $font-s;
}
</style>
